import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {
  fetchGroupsOfCustomerPaginated(
    word = null,
    sortName = "name",
    orderBy = "ASC",
    page = 1,
    itemsPerPage = 4,
    withTrashed = false,
    withModel = [],
    columns = ['*']
  ) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';

    return axios.post('', formatGraphqlBody(
      'query',
      'groupOfCustomerPaginated',
      {
        0: 'pagination_page',
        1: 'pagination_limit',
        2: 'total_pages',
        3: 'total_items',
        items: {
          0: 'id',
          1: 'name',
          2: 'color_tag',
          3: 'tag_list'
        }
      },
      {
        pagination_page: page, 
        pagination_limit: itemsPerPage,
        search_filter: word, 
        orderBy: [sortName, orderBy],
        with_trashed: withTrashed,
        with: withModel,
        columns: columns
      }
    ));
  },
  fetchGroupsOfCustomerTagListById(id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          groupsOfCustomer (
            id: ${id}
          ) {
            tag_list,
            has_diff_tag_list
          }
        }
      `
    });
  },
  fetchGroupsOfCustomerResume(
    word = null,
    sortName = "name",
    orderBy = "ASC",
    page = 1,
    itemsPerPage = 4,
    withTrashed = false,
    withModel = [],
    columns = ['*']
  ) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';

    return axios.post('', formatGraphqlBody(
      'query',
      'groupOfCustomerPaginated',
      {
        0: 'total_items',
        items: {
          0: 'id',
          1: 'name'
        }
      },
      {
        pagination_page: page, 
        pagination_limit: itemsPerPage,
        search_filter: word, 
        orderBy: [sortName, orderBy],
        with_trashed: withTrashed,
        with: withModel,
        columns: columns
      }
    ));
  },
  infosGroupOfCustomer(groupOfCustomerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          groupOfCustomerInfos (
            id: ${groupOfCustomerId}
          ) {
            id,
            name,
            color_tag,
            customers {
              id,
              name,
              phone_number
            },
            tag_list
          }
        }
      `
    })
  },
  addGroupOfCustomer(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createGroupOfCustomer (
            name: "${data.name}",
            color_tag: "${data.color_tag}",
            chosen_customers: [${data.chosenCustomers.join(',')}],
            remove_rows: [${data.removeRows.join(',')}],
            sheet_url: ${data.sheetUrl ? '"' + data.sheetUrl + '"' : null}
            update_all_in_sheet: ${data.updateAllInSheet}
          ) {
            id,
            name
          }
        }
      `
    })
  },
  updateGroupOfCustomer(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateGroupOfCustomer (
            id: ${data.id},
            name: "${data.name}",
            color_tag: "${data.color_tag}",
            chosen_customers: [${data.chosenCustomers.join(',')}],
            clean_customers : ${data.chosenCustomers.length === 0},
            change_customers : ${data.changeCustomers}
          ) {
            id,
            name
          }
        }
      `
    })
  },
  deleteGroupOfCustomer(groupOfCustomerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteGroupOfCustomer (
            id: ${groupOfCustomerId}
          )
        }
      `
    })
  },
  fetchCustomerGroups(customerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customerGroups (
            customer_id: ${customerId}
          ) {
            id,
            group {
              id,
              name,
              color_tag
            }
          }
        }
      `
    })
  },
  deleteCustomerGroup(customerGroupId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteCustomerGroup (
            id: ${customerGroupId}
          )
        }
      `
    })
  },
  fetchDiffGroupsOfCustomer(removeIds = []) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          groupsOfCustomer (
            remove_ids: [${removeIds.join(',')}]
          ) {
            id,
            name,
            color_tag
          }
        }
      `
    })
  },
  fetchGroupOfCustomerCustomers(groupId, page, limit) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          groupOfCustomerCustomers (
            group_id: ${groupId},
            pagination_page: ${page},
            pagination_limit: ${limit}
          ) {
            total_pages,
            total_items,
            items {
              customer {
                id,
                name,
                phone_number
              },
              color_tag,
              sheet_tags
            }
          }
        }
      `
    })
  },
}
